<script setup lang="ts">
import { computed, type PropType } from 'vue'
import type { ObjectTreeItemType } from '@/entities/ObjectsTree/model/types'
import { VIcons } from '@/shared/ui'

const props = defineProps({
  item: {
    type: Object as PropType<ObjectTreeItemType>,
    required: true,
  },
})

/* Вычисляем класс иконки */
const iconClass = computed(() => {
  if (props.item.type == 3) return ''

  switch (props.item.status) {
    case 0:
      return 'v-tree__icon_inactive'
    case 1:
      return 'v-tree__icon_success'
    case 2:
      return 'v-tree__icon_warning'
    case 3:
      return 'v-tree__icon_error'
  }
})
</script>

<template>
  <VIcons class="v-tree__icon" :class="iconClass" :type="item.icon" />
</template>
